import { useQuery } from '@tanstack/react-query'

import { api } from '../../../services/api'
import { DocumentsByUserData } from '../../../types/interfaces'
import { queriesKeys } from '../queriesKeys'

export const useGetDocuments = () =>
  useQuery<DocumentsByUserData>({
    queryFn: () => api.documents.getDocuments(),
    queryKey: queriesKeys.documents.getDocuments,
  })
